export const GET_PLATFORM_SETTINGS = "GET_PLATFORM_SETTINGS"
export const GET_PLATFORM_SETTINGS_SUCCESS = "GET_PLATFORM_SETTINGS_SUCCESS"
export const GET_PLATFORM_SETTINGS_FAILED = "GET_PLATFORM_SETTINGS_FAILED"

export const UPDATE_PLATFORM_SETTINGS = "UPDATE_PLATFORM_SETTINGS"
export const UPDATE_PLATFORM_SETTINGS_SUCCESS =
  "UPDATE_PLATFORM_SETTINGS_SUCCESS"
export const UPDATE_PLATFORM_SETTINGS_FAILED = "UPDATE_PLATFORM_SETTINGS_FAILED"

export const GET_ICONS = "GET_ICONS"
export const GET_ICONS_SUCCESS = "GET_ICONS_SUCCESS"
export const GET_ICONS_FAILED = "GET_ICONS_FAILED"

export const GET_SOCIAL_PROFILE_SETTINGS = "GET_SOCIAL_PROFILE_SETTINGS"
export const GET_SOCIAL_PROFILE_SETTINGS_SUCCESS =
  "GET_SOCIAL_PROFILE_SETTINGS_SUCCESS"
export const GET_SOCIAL_PROFILE_SETTINGS_FAILED =
  "GET_SOCIAL_PROFILE_SETTINGS_FAILED"

export const UPDATE_SOCIAL_PROFILE_SETTINGS = "UPDATE_SOCIAL_PROFILE_SETTINGS"
export const UPDATE_SOCIAL_PROFILE_SETTINGS_SUCCESS =
  "UPDATE_SOCIAL_PROFILE_SETTINGS_SUCCESS"
export const UPDATE_SOCIAL_PROFILE_SETTINGS_FAILED =
  "UPDATE_SOCIAL_PROFILE_SETTINGS_FAILED"

export const GET_WEBSITE_CONFIGS = "GET_WEBSITE_CONFIGS"
export const GET_WEBSITE_CONFIGS_SUCCESS = "GET_WEBSITE_CONFIGS_SUCCESS"
export const GET_WEBSITE_CONFIGS_FAILED = "GET_WEBSITE_CONFIGS_FAILED"

export const UPDATE_WEBSITE_CONFIGS = "UPDATE_WEBSITE_CONFIGS"
export const UPDATE_WEBSITE_CONFIGS_SUCCESS = "UPDATE_WEBSITE_CONFIGS_SUCCESS"
export const UPDATE_WEBSITE_CONFIGS_FAILED = "UPDATE_WEBSITE_CONFIGS_FAILED"
